// the secret is pretty much there to identify wetransfer pages
// while we are history pushing/popping, not really secret.
const secret = 'wt';

export default {
  replace(path, title = document.title) {
    if (typeof window.history.replaceState !== 'function') {
      return this.forceNavigate(path);
    }

    setTimeout(() => {
      window.history.replaceState({ secret }, title, path);
      document.title = title;
    }, 0);
  },

  push(path, title = document.title) {
    if (typeof window.history.pushState !== 'function') {
      return this.forceNavigate(path);
    }

    window.history.pushState({ secret }, title, path);
    document.title = title;
  },

  forceNavigate(path = '/') {
    if (window.location.pathname !== path) {
      window.location.href = path;
    }
  },

  listen(callback) {
    // We listen to the hashchange for segment changes
    window.addEventListener('hashchange', () => {
      // Go to the new location
      callback(window.location.pathname, window.location);
    });

    // We listen to the popstate for history changes
    window.addEventListener(
      'popstate',
      (e) => {
        // Is this a Routed history item?
        if (!e || !e.state || e.state.secret !== secret) {
          return;
        }

        // Go to the new location
        callback(window.location.pathname, window.location);
      },
      false
    );
  },
};
